export default __webpack_public_path__ + "static/media/4.78e35929.png";